import { FormError } from 'shared/components/FormControl';

import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';
import TextArea from 'design-system/components/TextArea';
import { useFormSecurely as useForm } from 'lib/security/reactHookForm';

interface FormReportFlagIssuesProps {
  onSubmit: (data: FormReportFlagIssuesData) => void;
  handleCancel: () => void;
}

export const FormReportFlagIssues = ({ onSubmit, handleCancel }: FormReportFlagIssuesProps) => {
  const {
    handleSubmit,
    register,
    formState: { isSubmitting, isDirty, isValid, errors },
  } = useForm<{ description: string }>({ mode: 'onChange' });

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Spacer height={2} />
      <Label size='sm' htmlFor='form-report-flag-issues__description'>
        Please describe the issue. Include as much detail as possible.
      </Label>
      <Spacer height={1} />
      <TextArea
        id='form-report-flag-issues__description'
        placeholder='Describe your issue here...'
        {...register('description', { required: 'Please enter a description of your issue' })}
      />
      {errors.description && <FormError>{errors.description.message}</FormError>}
      <Spacer height={2} />
      <HStack equal={true}>
        <Button
          variant='basic'
          id='form-flag-issue-report__cancel'
          disabled={isSubmitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          disabled={!isDirty || !isValid || isSubmitting}
          isPending={isSubmitting}
        >
          Flag issue
        </Button>
      </HStack>
    </Form>
  );
};

export interface FormReportFlagIssuesData {
  description: string;
}
